'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../tslib.es6-CZ43up4V.js');
const jsxRuntime = require('react/jsx-runtime');
const React = require('react');
const reactAria = require('react-aria');
const reactAriaComponents = require('react-aria-components');
const Description_Description = require('../Description/Description.cjs.js');
const Label_Label = require('../Label/Label.cjs.js');
const utils_mergeClassNames = require('../utils/mergeClassNames.cjs.js');
const SelectBase_ListBox = require('./ListBox.cjs.js');
const SelectBase_Popover = require('./Popover.cjs.js');
const SelectBase_SelectContext = require('./SelectContext.cjs.js');
const SelectBase_SelectValue = require('./SelectValue.cjs.js');
const SelectBase_TriggerButton = require('./TriggerButton.cjs.js');

const selectBase = "_select-base_haqg4_1";
const styles = {
	selectBase: selectBase
};

const defaultProps = {
  isDisabled: false,
  isRequired: false,
  size: "medium"
};
const SelectBase = (_a) => {
  var { className } = _a, props = tslib_es6.__rest(_a, ["className"]);
  const propsWithDefaults = Object.assign(Object.assign({}, defaultProps), props);
  const { defaultSelectedKey, isDisabled = false, isInvalid = false, isRequired = false, onSelectionChange, selectedKey, size = "medium" } = propsWithDefaults;
  const descriptionProps = { isCompact: size === "compact" };
  const labelProps = {
    isCompact: size === "compact",
    isDisabled,
    isInvalid,
    isRequired
  };
  const listBoxProps = { size };
  const popoverProps = { size };
  const selectValueProps = { size };
  const triggerButtonProps = { size };
  const isSSR = reactAria.useIsSSR();
  const [disabledKeys, setDisabledKeys] = React.useState([]);
  const selectContextValue = React.useMemo(() => ({
    registerDisabledItem: (id) => {
      setDisabledKeys((prev) => [...prev, id]);
    },
    size
  }), [size]);
  if (isSSR) {
    return null;
  }
  return jsxRuntime.jsx(reactAriaComponents.Provider, { values: [
    [Description_Description.DescriptionContext, descriptionProps],
    [Label_Label.LabelContext, labelProps],
    [SelectBase_ListBox.ListBoxContext, listBoxProps],
    [SelectBase_Popover.PopoverContext, popoverProps],
    [SelectBase_SelectContext.SelectContext, selectContextValue],
    [SelectBase_SelectValue.SelectValueContext, selectValueProps],
    [SelectBase_TriggerButton.TriggerButtonContext, triggerButtonProps]
  ], children: jsxRuntime.jsx(reactAriaComponents.Select, Object.assign({}, props, { className: (renderProps) => utils_mergeClassNames.mergeClassNames([styles.selectBase, className], renderProps), "data-size": size, "data-zds": true, defaultSelectedKey, disabledKeys, onSelectionChange, isInvalid, selectedKey })) });
};
SelectBase.Description = Description_Description.Description;
SelectBase.TriggerButton = SelectBase_TriggerButton.TriggerButton;
SelectBase.ListBox = SelectBase_ListBox.ListBox;
SelectBase.Popover = SelectBase_Popover.Popover;
SelectBase.Value = SelectBase_SelectValue.SelectValueBase;
SelectBase.Label = Label_Label.Label;

exports.SelectBase = SelectBase;
//# sourceMappingURL=SelectBase.cjs.js.map
